import { Menu, UnstyledButton } from '@mantine/core';
// components
import { EllipsisVertical, Plus, Trash2 } from 'lucide-react';
import { openConfirmDeleteModal } from '@/utils/ui.tsx';
// icons
// utils
import { useCustomerDeleteAllAttributesMutation } from '@/services/customer/customer/customer.queries.ts';

interface ContextMenuProps {
    refetch: () => void;
    onAdd: () => void;
}

const ContextMenu = ({ refetch, onAdd }: ContextMenuProps) => {
    const { mutate: deleteAllAttributes } =
        useCustomerDeleteAllAttributesMutation();
    const handleDeleteAll = () => {
        openConfirmDeleteModal({
            title: `Delete all attributes?`,
            children: `Are you sure you want to delete all attributes?`,
            confirmLabel: 'Delete All Attributes',
            onConfirm: () => {
                deleteAllAttributes(undefined, {
                    onSuccess: () => {
                        refetch();
                    }
                });
            }
        });
    };

    return (
        <Menu withArrow>
            <Menu.Target>
                <UnstyledButton>
                    <EllipsisVertical />
                </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item leftSection={<Plus />} onClick={onAdd}>
                    Add Attribute
                </Menu.Item>
                <Menu.Item
                    className="text-red-6"
                    leftSection={<Trash2 />}
                    onClick={handleDeleteAll}
                >
                    Delete All Attributes
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};

export default ContextMenu;
